import React from 'react';
import { connect } from 'react-redux';

import { IAppState } from 'src/store';

const Form: React.FC<Props> = ({ children, ...props }) => {
  return <form {...props}>{children}</form>;
};

type Props = ReturnType<typeof mapStateToProps> &
  typeof mapDispatchToProps &
  React.DetailedHTMLProps<React.FormHTMLAttributes<HTMLFormElement>, HTMLFormElement>;

const mapStateToProps = (state: IAppState) => ({});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(Form);
